import * as React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { useEffect } from "react";

export default function QuestionsBankListItem({
  bankId,
  questionText,
  handleToggleAdd,
  handleToggleRemove,
  isRemove,
  isDisabled,
  isSelected,
  index
}) {
  const [checked, setChecked] = React.useState(isSelected || false);
  useEffect(() => {
    setChecked(isSelected);
  },[isSelected]);

  const handleCheckbox = (value) => () => {

    
    // const currentIndex = checked.indexOf(value);
    // const newChecked = [...checked];

    // if (currentIndex === -1) {
    //   newChecked.push(value);
       if (isRemove) {
         handleToggleRemove(value, !checked, index);
       } else {
         handleToggleAdd(value, !checked);
      }

    setChecked((prevChecked) => !prevChecked);

    // } else {
    //   newChecked.splice(currentIndex, 1);
    //   if (isRemove) {
    //     handleToggleAdd(value);
    //   } else {
    //     handleToggleRemove(value);
    //   }
    // }
    // setChecked(newChecked);
  };

  return (
    <ListItem key={bankId} disablePadding>
      <ListItemButton role={undefined} onClick={handleCheckbox(bankId)} dense>
        <ListItemIcon>
        <Checkbox
            disabled={isDisabled}
            edge="start"
            // checked={isDisabled ? false : checked.indexOf(bankId) !== -1}
            checked={isDisabled ? false : checked}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": bankId }}
          />
        </ListItemIcon>
        <ListItemText id={bankId} primary={questionText} className={`${isDisabled ? "text-muted": ""}`} />
      </ListItemButton>
    </ListItem>
  );
}
